import React from 'react';

const Services = () => {
  const services = [
    { title: "OPTICAL NEEDS", icon: "fa-user-doctor" },
    { title: "CONTACT LENSES", icon: "fa-circle-dot" },
    { title: "EYE INVESTIGATIONS", icon: "fa-users" },
    { title: "VISION THERAPY", icon: "fa-crosshairs" },
    { title: "LOW VISION", icon: "fa-eye-slash" },
    { title: "SPORT VISION", icon: "fa-magnifying-glass" }
  ];

  return (
    <section id="services" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-16">
        {/* Header Section */}
        <div className="text-center space-y-6">
          <div className="inline-block">
            <h2 className="text-4xl lg:text-5xl font-extrabold text-slate-800 tracking-tight mb-2">
              High-Quality Services
            </h2>
            <div className="w-24 h-1.5 bg-syana-blue-600 mx-auto rounded-full"></div>
          </div>
          <p className="text-slate-500 max-w-5xl mx-auto text-base lg:text-lg leading-relaxed font-medium">
            Siyane Optometrists uses an innovative approach coupled with state-of-the-art equipment handled by our professionals to deliver high quality services across the island.
          </p>
        </div>
      </div>

      {/* Static Single Row Services */}
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {services.map((service, i) => (
            <div 
              key={i} 
              className="group flex flex-col items-center text-center p-6 bg-slate-50/50 rounded-xl hover:bg-white hover:shadow-xl hover:shadow-slate-200 transition-all duration-500 border border-slate-100/50"
            >
              {/* Dashed Circular Border Container */}
              <div className="relative w-20 h-20 mb-4 flex items-center justify-center">
                <div className="absolute inset-0 border-[1.5px] border-dashed border-syana-blue-600/30 rounded-full group-hover:rotate-180 transition-transform duration-1000"></div>
                <div className="w-14 h-14 bg-syana-blue-600/10 rounded-full flex items-center justify-center group-hover:bg-syana-blue-600 transition-all duration-500">
                  <i className={`fa-solid ${service.icon} text-lg text-syana-blue-600 group-hover:text-white transition-colors`}></i>
                </div>
              </div>
              
              <h3 className="text-[10px] lg:text-xs font-black text-syana-blue-900 tracking-wider uppercase leading-tight">
                {service.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
